import React from 'react';
import * as Styled from './CheckIframe.styles';


interface CheckIframeProps {
  url?: string;
}

const CheckIframe: React.FC<CheckIframeProps> = ({ url }) => {
  return <Styled.IFrame title='SOLID Seminare' src={url} />;
};

export default CheckIframe;
